/* eslint-disable max-lines-per-function */
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import './modal.scss';
import ButtonComponent from '../Button/Button';

const FormDialog = ({
  title,
  open,
  handleClose,
  button1Action,
  button2Action,
  paperprops,
  dialogCss,
  dialogPaperCss,
  dialogBodycontent,
  button1,
  button2,
  cancelButtonId,
  submitButtonId,
  button2Disabled,
  isPopUp,
  isSessionPopup,
  isCheckBox,
  handleCheckBox,
  checkbox,
}) => {
  const getButtonClass = () => {
    if (button2Disabled) return 'modal-btn-disabled';
    if (isPopUp) return 'popup-button';
    if (isSessionPopup) return 'login-button';
    return 'modal-btn';
  };
  const btnCss = getButtonClass();

  return (
    <Dialog
      className={`dialog-component ${dialogCss}`}
      open={open}
      onClose={handleClose}
      PaperProps={{
        className: `dialog-paper ${dialogPaperCss}`,
        ...paperprops,
      }}
    >
      {title && <DialogTitle className="dialog-title">{title}</DialogTitle>}
      <DialogContent className="dialog-content">
        {dialogBodycontent}
        {isCheckBox && (
          <div className="cancel-email">
            <input
              className='checkbox'
              type="checkbox"
              value={checkbox}
              onChange={(event) => handleCheckBox(event)}
            />
            <label className='checkbox-label'>Send session cancellation email</label>
          </div>
        )}
      </DialogContent>
      <DialogActions className="dialog-actions">
        {button1 && (
          <ButtonComponent
            label={button1}
            variant="text"
            onClick={button1Action}
            btnCss="cancel-btn"
            id={cancelButtonId}
          ></ButtonComponent>
        )}
        {button2 && (
          <ButtonComponent
            label={button2}
            variant="contained"
            onClick={button2Action}
            lete
            r
            btnCss={btnCss}
            id={submitButtonId}
            disabled={button2Disabled}
          ></ButtonComponent>
        )}
      </DialogActions>
    </Dialog>
  );
};

FormDialog.propTypes = {
  title: PropTypes.any.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.any,
  button1Action: PropTypes.any.isRequired,
  button2Action: PropTypes.any.isRequired,
  paperprops: PropTypes.any,
  dialogCss: PropTypes.string,
  dialogPaperCss: PropTypes.string.isRequired,
  dialogBodycontent: PropTypes.any.isRequired,
  button1: PropTypes.string.isRequired,
  button2: PropTypes.string.isRequired,
  cancelButtonId: PropTypes.string.isRequired,
  submitButtonId: PropTypes.string.isRequired,
  button2Disabled: PropTypes.bool,
  isPopUp: PropTypes.bool,
  isSessionPopup: PropTypes.bool,
  isCheckBox: PropTypes.bool,
  handleCheckBox: PropTypes.func,
  checkbox: PropTypes.bool,
};

export default FormDialog;
